export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox={props.viewBox ?? "0 0 24 24"}
      fill={props.fill ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke={props.stroke ?? "#ff9000"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap="round"
      />
      <path
        d="M5 12H19"
        stroke={props.stroke ?? "#ff9000"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap="round"
      />
    </svg>
  );
};